module.exports = __webpack_public_path__ + "img/selosc.d9936df6.png";